import { Formik, Form } from "formik";
import React, { useEffect, useRef, useState } from "react";

import Select from "~components/Form/components/Select";
import { CleanFiltersIcon } from "~misc/icons";
import "./style.scss";
import usePesquisa from "~fetchs/usePesquisa";
import usePesquisaVigente from "~fetchs/usePesquisaVigente";
import usePesquisaStatus from "~fetchs/usePesquisaStatus";
import usePesquisaPeriodo from "~fetchs/usePesquisaPeriodo";
const FilterList = ({ onFilterChange, removeCliente, removeValidityPeriod, titulos }) => {
  const [searchTextInput, setSearchTextInput] = useState("");

  const formikRef = useRef();
  const [keys, setKeys] = useState({
    searchText: `select-carteira-searchText`,
    title: `select-carteira-title`,
    status: `select-carteira-status`,
    period: `select-carteira-period`,
    validityPeriod: `select-carteira-validityPeriod`,
    tipo: `select-carteira-tipo`,
  });

  const dadosVigente = [
    { label: "Todos", value: "Todos" },
    { label: "Sim", value: "Sim" },
    { label: "Não", value: "Não" },
  ];
  const dadosStatus = [
    { label: "Todos", value: "Todos" },
    { label: "Pesquisado", value: "Pesquisado" },
    { label: "Não Pesquisado", value: "Não Pesquisado" },
  ];

  const dadosPeriodo = [
    { label: "Todos", value: "Todos" },
    { label: "Hoje", value: "last1days" },
    { label: "Últimos 3 dias", value: "last3days" },
    { label: "Últimos 5 dias", value: "last5days" },
    { label: "Últimos 7 dias", value: "last7days" },
    { label: "Últimos 14 dias", value: "last14days" },
    { label: "Últimos 30 dias", value: "last30days" },
    { label: "Últimos 60 dias", value: "last60days" },
    { label: "Últimos 90 dias", value: "last90days" },
  ];

  const { optionsPesquisa, onChangePesquisa, pesquisaSelect } = usePesquisa(
    formikRef,
    titulos,
    {
      salvarLocalStorage: true,
      chave: keys.title,
    },
    onFilterChange
  );

  const { optionsPesquisaVigente, onChangePesquisaVigente, pesquisaSelectVigente } = usePesquisaVigente(
    formikRef,
    dadosVigente,
    {
      salvarLocalStorage: true,
      chave: keys.validityPeriod,
    },
    onFilterChange
  );

  const { optionsPesquisaStatus, onChangePesquisaStatus, pesquisaSelectStatus } = usePesquisaStatus(
    formikRef,
    dadosStatus,
    {
      salvarLocalStorage: true,
      chave: keys.status,
    },
    onFilterChange
  );

  const { optionsPesquisaPeriodo, onChangePesquisaPeriodo, pesquisaSelectPeriodo } = usePesquisaPeriodo(
    formikRef,
    dadosPeriodo,
    {
      salvarLocalStorage: true,
      chave: keys.period,
    },
    onFilterChange
  );

  useEffect(() => {
    const savedValue = localStorage.getItem(keys.searchText);
    if (savedValue) {
      setSearchTextInput(savedValue);
    }
  }, [keys.searchText]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTextInput(value);
    localStorage.setItem(keys.searchText, value);
  };

  useEffect(() => {
    const savedValue = localStorage.getItem(keys.searchText);
    console.log(`teste`, savedValue);
    if (savedValue) {
      setSearchTextInput(savedValue);
      onFilterChange((prev) => ({
        ...prev,
        searchText: savedValue,
      }));
    }
  }, []);

  const handleResetFilters = () => {
    setSearchTextInput("");
    onFilterChange({
      searchText: "",
      title: "Todas",
      status: "Todos",
      period: "Todos",
      validityPeriod: "Todos",
    });

    onChangePesquisa({ value: 0, label: "Todos" });
    onChangePesquisaVigente({ label: "Todos", value: "Todos", escritorioVendaId: null });
    onChangePesquisaStatus({ label: "Todos", value: "Todos", escritorioVendaId: null });
    onChangePesquisaPeriodo({ label: "Todos", value: "Todos", escritorioVendaId: null });
    localStorage.removeItem(keys.searchText);
  };

  const handleSearchClick = () => {
    onFilterChange((prev) => ({
      ...prev,
      searchText: searchTextInput,
    }));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const value = e.target.value;
      setSearchTextInput(value);
      onFilterChange((prev) => ({
        ...prev,
        searchText: value,
      }));
    }
  };

  return (
    <Formik
      initialValues={{
        searchText: "",
        title: "Todas",
        status: "Todos",
        period: "Todos",
        validityPeriod: "Todos",
      }}
      onSubmit={() => {}}
    >
      {({ resetForm }) => (
        <Form className="container bg-white p-5 border-terciaria border rounded-b-lg border-t-2 mt-4 flex-col md:flex-row gap-y-4">
          {!removeCliente && (
            <div action="" className="grow relative flex items-center mb-2">
              <input
                className="input-search w-full text-[#1C2B58] py-5 pl-5 pr-10 rounded-lg h-[48px] border border-solid border-gray-300 placeholder-[#1C2B58] text-16"
                type="text"
                placeholder="Buscar cliente"
                name="searchText"
                value={searchTextInput}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
              />
              <button onClick={handleSearchClick} className="absolute top-50 right-0 p-4 z-2" type="button">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.275 0.181774C5.925 0.500525 4.0125 1.62552 2.86875 2.75052C0.975 4.66302 0 7.00677 0 9.72552C0 12.3693 0.99375 14.713 2.90625 16.588C5.90625 19.5318 10.2938 20.2443 13.9875 18.4255L15.2813 17.788L18.2812 20.9005C21.075 23.788 21.3188 23.9943 21.9563 23.9755C22.7812 23.9755 23.25 23.5068 23.25 22.6818C23.25 22.1755 22.8563 21.6693 20.3438 19.0443C18.75 17.3755 17.4375 15.9505 17.4375 15.8943C17.4375 15.8193 17.7375 15.2755 18.0938 14.6755C19.1063 13.0255 19.4062 11.8255 19.3875 9.53802C19.3875 7.32553 19.125 6.38803 18.075 4.62552C16.8 2.54428 14.7563 0.969275 12.3938 0.275524C11.2875 -0.0432262 8.45625 -0.0994759 7.275 0.181774ZM12.6188 3.31302C18.0938 5.86303 18.0563 13.4755 12.5625 16.0818C11.6813 16.4943 11.2875 16.5693 9.75 16.5693C8.2125 16.5693 7.81875 16.4943 6.9 16.063C3.95625 14.6943 2.26875 11.5818 2.8125 8.56303C3.65625 3.93177 8.45625 1.36303 12.6188 3.31302Z"
                    fill="#D0D4E4"
                  />
                </svg>
              </button>
            </div>
          )}
          <div
            className={`grid grid-cols-${removeValidityPeriod ? "1" : "2"} gap-x-${
              removeValidityPeriod ? "1" : "2"
            } content-select`}
          >
            <Select
              name="pesquisa"
              label="Pesquisa:"
              placeholder="Pesquisa:"
              options={optionsPesquisa}
              noOptionsMessage="Pesquisa não encontrada"
              onChange={onChangePesquisa}
              {...pesquisaSelect}
            />

            {!removeValidityPeriod && (
              <Select
                name="pesquisaVigente"
                label="Pesquisa Vigente:"
                placeholder="Pesquisa Vigente:"
                options={optionsPesquisaVigente}
                noOptionsMessage="Pesquisa Vigente não encontrada"
                onChange={onChangePesquisaVigente}
                {...pesquisaSelectVigente}
              />
            )}
          </div>
          <div className="grid grid-cols-2 gap-x-2 content-select">
            <Select
              name="pesquisaStatus"
              label="Status de Solicitação:"
              placeholder="Status de Solicitação:"
              options={optionsPesquisaStatus}
              noOptionsMessage="Pesquisa Status não encontrada"
              onChange={onChangePesquisaStatus}
              {...pesquisaSelectStatus}
            />

            <Select
              name="pesquisaPeriodo"
              label="Período de Resposta:"
              placeholder="Período de Resposta:"
              options={optionsPesquisaPeriodo}
              noOptionsMessage="Pesquisa Status não encontrada"
              onChange={onChangePesquisaPeriodo}
              {...pesquisaSelectPeriodo}
            />
          </div>
          <div>
            <button
              className="flex items-center gap-4 ml-auto
                      mt-4  cursor-pointer"
              onClick={() => {
                handleResetFilters();
                resetForm();
              }}
            >
              <span className="font-semibold text-lg cursor-pointer">Limpar Filtros</span>
              <CleanFiltersIcon />
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default FilterList;
